export default __webpack_public_path__ + "static/media/ivycity.9a80a98d.png";